import { api, API } from "./api";

const TOKEN_KEY = "fl_admin_token";

export function getAdminToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch {
    return "";
  }
}

export function setAdminToken(t) {
  try {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* noop */
  }
}

export function clearAdminToken() {
  setAdminToken("");
}

function authedHeaders() {
  return { Authorization: `Bearer ${getAdminToken()}` };
}

export async function adminLogin(email, password) {
  const { data } = await api.post("/admin/login", { email, password });
  setAdminToken(data.token);
  return data;
}

export async function adminMe() {
  const { data } = await api.get("/admin/me", { headers: authedHeaders() });
  return data;
}

export async function adminOverview(range = "7d") {
  const { data } = await api.get(`/admin/analytics/overview?range=${range}`, {
    headers: authedHeaders(),
  });
  return data;
}

export async function adminTop(range = "30d") {
  const { data } = await api.get(`/admin/analytics/top?range=${range}`, {
    headers: authedHeaders(),
  });
  return data;
}

export async function adminTimeseries(range = "30d") {
  const { data } = await api.get(
    `/admin/analytics/timeseries?range=${range}`,
    { headers: authedHeaders() },
  );
  return data;
}

export async function adminRecent(limit = 100) {
  const { data } = await api.get(`/admin/analytics/recent?limit=${limit}`, {
    headers: authedHeaders(),
  });
  return data;
}

export async function adminEmails(limit = 50) {
  const { data } = await api.get(`/admin/analytics/emails?limit=${limit}`, {
    headers: authedHeaders(),
  });
  return data;
}


// ----- AutoBlog (super-admin) -----

export async function autoblogStatus() {
  const { data } = await api.get("/super-admin/autoblog/status", {
    headers: authedHeaders(),
  });
  return data;
}

export async function autoblogPlan() {
  const { data } = await api.get("/super-admin/autoblog/plan", {
    headers: authedHeaders(),
  });
  return data;
}

export async function autoblogKeywords() {
  const { data } = await api.get("/super-admin/autoblog/keywords", {
    headers: authedHeaders(),
  });
  return data;
}

export async function autoblogToggle(enabled) {
  const { data } = await api.post(
    "/super-admin/autoblog/toggle",
    { enabled },
    { headers: authedHeaders() },
  );
  return data;
}

export async function autoblogGeneratePlan() {
  const { data } = await api.post(
    "/super-admin/autoblog/plan",
    {},
    { headers: authedHeaders(), timeout: 180000 },
  );
  return data;
}

export async function autoblogRunNow() {
  const { data } = await api.post(
    "/super-admin/autoblog/run-now",
    {},
    { headers: authedHeaders(), timeout: 180000 },
  );
  return data;
}

export async function autoblogPublishBatch({ plan_ids = [], all = false }) {
  const { data } = await api.post(
    "/super-admin/autoblog/publish-batch",
    { plan_ids, all },
    { headers: authedHeaders(), timeout: 180000 },
  );
  return data;
}

export async function autoblogPublishTopic({ title, angle = "" }) {
  const { data } = await api.post(
    "/super-admin/autoblog/publish-topic",
    { title, angle },
    { headers: authedHeaders(), timeout: 180000 },
  );
  return data;
}

export async function autoblogSkipPlan(planId) {
  const { data } = await api.delete(
    `/super-admin/autoblog/plan/${planId}`,
    { headers: authedHeaders() },
  );
  return data;
}

export async function autoblogLowKdPreview() {
  const { data } = await api.get(
    "/super-admin/autoblog/low-kd/preview",
    { headers: authedHeaders() },
  );
  return data;
}

export async function autoblogLowKdGenerate() {
  const { data } = await api.post(
    "/super-admin/autoblog/low-kd/generate",
    {},
    { headers: authedHeaders(), timeout: 180000 },
  );
  return data;
}

// Public list of local posts (for the admin "recently published" panel).
export async function adminListBlogPosts() {
  const { data } = await api.get("/super-admin/blog", {
    headers: authedHeaders(),
  });
  return data;
}

export async function adminDeleteBlogPost(postId) {
  const { data } = await api.delete(`/super-admin/blog/${postId}`, {
    headers: authedHeaders(),
  });
  return data;
}


export { API };
